import React, { Component } from 'react';
import { connect } from 'react-redux';
import Collapsible from 'react-collapsible';
import BookingInformation from './InvoiceBookingInformation';
import InvoiceProperties from './InvoiceProperties';
import InvoiceLines from './InvoiceLines';
import InvoiceEInvoiceData from './InvoiceEInvoiceData';
import WarningsAndDeleteLog from './WarningsAndDeleteLog';
import ReportVATReturn from './ReportVATReturn';
import ReportECL from './ReportECL';
import ReportLL from './ReportLL';
import ReportRCL from './ReportRCL';
import ReportLedgers from './ReportLedgers';
import ReportIntrastat from './ReportIntrastat';
import ReportExtrastat from './ReportExtrastat';
import ReportRefund from './ReportRefund';
import ReportSII from './ReportSII';
import TRANSACTIONS_CONTROLLER from '../../controllers/transactions';
import AttachmentUploadModal from './AttachmentUploadModal';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

import FormattedDate from '../fields/dates/FormattedDate';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReportOSS from './ReportOSS';
const log = new Logger('TRANSACTION_INVOICE', LOG_LEVELS.DEBUG);

class TransactionInvoice extends Component {

  constructor(props) {
    super(props);
    this.state = {
      comment: "",
      newComment: "",
      attachmentDescription: "",
      attachmentDescriptionReset: false,
      attachmentFileUrl: "",
      attachmentUri: "",
      attachmentName: "",
      attachmentMimeType: "",
      attachmentUploadModalOpen: false
    };
    this.addTransactionComment = this.addTransactionComment.bind(this);
    this.onSaveTransactionCommentClick = this.onSaveTransactionCommentClick.bind(this);
    this.updateTransactionComment = this.updateTransactionComment.bind(this);
    this.onDeleteTransactionCommentClick = this.onDeleteTransactionCommentClick.bind(this);
    this.deleteTransactionComment = this.deleteTransactionComment.bind(this);
    this.addTransactionAttachment = this.addTransactionAttachment.bind(this);
    this.onDownloadTransactionAttachmentClick = this.onDownloadTransactionAttachmentClick.bind(this);
    this.onUploadTransactionAttachmentClick = this.onUploadTransactionAttachmentClick.bind(this);
    this.onAttachmentUploadCloseModal = this.onAttachmentUploadCloseModal.bind(this);
    this.onAttachmentUploadSubmitModal = this.onAttachmentUploadSubmitModal.bind(this);
    this.onDeleteTransactionAttachmentClick = this.onDeleteTransactionAttachmentClick.bind(this);
    this.deleteTransactionAttachment = this.deleteTransactionAttachment.bind(this);
  }

  getTransactionComment() {
    if (this.props.invoice.id > 0) {
      this.props.doGetTransactionComment(this.props.invoice.id, this.addTransactionComment);
    }
  }

  addTransactionComment(error, response) {
    if (response !== null) {
      this.setState({ comment: response.comment, newComment: "" });
    }
  }

  onNewCommentEntered(evt) {
    return (evt) => {
      let newComment = evt.target.value;
      log.debug('newCommentEntered: ', newComment);
      this.setState({ newComment });
    };
  }

  onSaveTransactionCommentClick() {
    if ((this.state.newComment !== this.state.comment) && (this.props.invoice.id > 0)) {
      this.props.doPutTransactionComment(this.props.invoice.id, this.state.newComment, this.updateTransactionComment);
    }
  }

  updateTransactionComment(error, response) {
    if (response !== null) {
      this.props.doGetTransactionComment(this.props.invoice.id, this.addTransactionComment);
    }
  }

  onDeleteTransactionCommentClick() {
    if (this.props.invoice.id > 0) {
      this.props.doDeleteTransactionComment(this.props.invoice.id, this.deleteTransactionComment);
    }
  }

  deleteTransactionComment(error, response) {
    if (response !== null) {
      this.setState({ comment: "" });
    }
  }

  getTransactionAttachment() {
    if (this.props.invoice.id > 0) {
      this.props.doGetTransactionAttachment(this.props.invoice.id, this.addTransactionAttachment);
    }
  }

  addTransactionAttachment(error, response) {
    if (response !== null) {
      let extension = response.attachmentFileUrl.split('.').pop();
      let mimeType;
      switch (extension.toUpperCase()) {
        case 'PDF':
          mimeType = 'application/pdf';
          break;
        case 'ZIP':
          mimeType = 'application/zip';
          break;
        case 'XLSX':
        case 'XLS':
          mimeType = 'application/vnd.ms-excel';
          break;
        default:
          mimeType = 'text/plain';
      };
      this.setState({ attachmentDescription: response.attachmentDescription, attachmentFileUrl: response.attachmentFileUrl, attachmentUri: response.attachmentUri, attachmentName: response.attachmentName, attachmentMimeType: mimeType });
    }
  }

  onDownloadTransactionAttachmentClick() {
    this.props.doDownloadTransactionAttachment({ mimeType: this.state.attachmentMimeType, uri: this.state.attachmentUri, fileName: this.state.attachmentName })
  }

  onUploadTransactionAttachmentClick() {
    this.setState({
      attachmentUploadModalOpen: true
    });
  }

  onAttachmentUploadCloseModal() {
    this.setState({
      attachmentUploadModalOpen: false, attachmentDescriptionReset: !this.state.attachmentDescriptionReset
    });
  }

  onAttachmentUploadSubmitModal(attachmentData) {
    this.setState({
      attachmentUploadModalOpen: false, attachmentDescriptionReset: !this.state.attachmentDescriptionReset
    });
    this.props.doUploadTransactionAttachment(attachmentData, this.addTransactionAttachment);
  }

  onDeleteTransactionAttachmentClick() {
    if (this.props.invoice.id > 0) {
      this.props.doDeleteTransactionAttachment(this.props.invoice.id, this.deleteTransactionAttachment);
    }
  }

  deleteTransactionAttachment(error, response) {
    if (response !== null) {
      this.setState({ attachmentDescription: "", attachmentFileUrl: "", attachmentUri: "", attachmentName: "", attachmentMimeType: "" });
    }
  }

  componentDidMount() {
    this.getTransactionComment();
    this.getTransactionAttachment();
  }

  render() {
    log.debug('render(): ', this.props);
    log.debug('render(): deleteLog ', this.props.deleteLog);


    const invoice = this.props.invoice;

    const transactionHasComment = (this.state.comment !== undefined) && (this.state.comment !== "");
    const newCommentEntered = (this.state.newComment !== undefined) && (this.state.newComment !== "");
    const downloadAttachment = (this.state.attachmentName !== undefined) && (this.state.attachmentName !== "");

    const attachmentTrigger = <span><s-icon name="chevron-down"></s-icon> <LanguageStringResolver string='toggleTriggerAdditional' /></span>;
    const commentTrigger = <span><s-icon name="chevron-down"></s-icon> <LanguageStringResolver string='toggleTriggerComment' /></span>;
    const additionalTrigger = <span><s-icon name="chevron-down"></s-icon> <LanguageStringResolver string='toggleTriggerAttachment' /></span>;


    if (!invoice) {
      return (
        <div><LanguageStringResolver string='transactionInvoice_noData' /></div>
      )
    }

    return (
      <ReadOnlyWrapper>
        <div className="toggle-container">
          <h2><LanguageStringResolver string='transactionInvoice_reportedBy' /><span>: {invoice.companyCode} - {invoice.companyName}</span></h2>

          <InvoiceProperties
            invoiceProperties={invoice.invoiceProperties}
            transactionDate={invoice.transactionDate}
            originalTransactionDate={invoice.originalTransactionDate}
            clearingDate={invoice.clearingDate}
            clearingDocNo={invoice.clearingDocumentNumber}
            clearingInfo={invoice.clearingInfo}
            processingDate={invoice.processingDate}
            ownReference={invoice.ownReference}
            documentId={invoice.id}
            attachedDoc={invoice.attachedDocument}
          />

          <InvoiceLines
            invoiceLines={invoice.invoiceLines}
            currency1={invoice.invoiceProperties.currency}
            currency2={invoice.invoiceProperties.currency2}
            currency3={invoice.invoiceProperties.currency3}
          />

          <InvoiceEInvoiceData
            eInvoiceDataLines={invoice.eInvoiceDataLines}
          />

          <WarningsAndDeleteLog
            warnings={this.props.warnings}
            deleteLog={this.props.deleteLog}
          />

          <AttachmentUploadModal
            attachmentDescriptionReset={this.state.attachmentDescriptionReset}
            attachmentUpload={{ id: invoice.id }}
            open={this.state.attachmentUploadModalOpen}
            onClose={this.onAttachmentUploadCloseModal}
            onSubmit={this.onAttachmentUploadSubmitModal}
          />

          <div className="clear"></div>



          {/* Addition Document Data */}

          <div className="mt30">
            <Collapsible trigger={additionalTrigger}>
              <div className="p10">
                <div className="clear"></div>
                <p><span className="bold"><LanguageStringResolver string='transactionAttachment_name' /><span>: </span></span><span>{this.state.attachmentName}</span></p>
                <p className="mb10"><span className="bold"><LanguageStringResolver string='transactionAttachment_description' /><span>: </span></span><span>{this.state.attachmentDescription === "undefined" ? "" : this.state.attachmentDescription}</span></p>


                {downloadAttachment ?
                  <div>
                    <button className="primary" onClick={this.onUploadTransactionAttachmentClick} disabled><LanguageStringResolver string='transactionAttachment_upload' /></button>
                    <button className="secondary" onClick={this.onDownloadTransactionAttachmentClick} enabled excludeFromReadonly={true}><LanguageStringResolver string='transactionAttachment_download' /></button>
                    <button className="secondary" onClick={this.onDeleteTransactionAttachmentClick} enabled><LanguageStringResolver string='transactionAttachment_delete' /></button>
                  </div> :
                  <div>
                    <button className="primary" onClick={this.onUploadTransactionAttachmentClick} enabled><LanguageStringResolver string='transactionAttachment_upload' /></button>
                    <button className="secondary" onClick={this.onDownloadTransactionAttachmentClick} disabled><LanguageStringResolver string='transactionAttachment_download' /></button>
                    <button className="secondary" onClick={this.onDeleteTransactionAttachmentClick} disabled><LanguageStringResolver string='transactionAttachment_delete' /></button>
                  </div>
                }
              </div>
            </Collapsible>

            <Collapsible trigger={commentTrigger}>
              <div className="p10">
                <div className="clear"></div>

                {!this.state.comment ? (
                  <p className="mb10"><LanguageStringResolver string='transactionComment_noComment' /></p>
                ) : (
                  <p className="mb10">{this.state.comment}</p>
                )}

                <fieldset>
                  <input
                    type="text"
                    onChange={this.onNewCommentEntered().bind(this)}
                    name="comment"
                    className="mt10 mb10"
                    maxLength="250"
                    value={this.state.newComment}
                  >
                  </input>
                </fieldset>

                {transactionHasComment ?
                  <div>
                    {newCommentEntered ?
                      <button className="primary" onClick={this.onSaveTransactionCommentClick} enabled><LanguageStringResolver string='transactionComment_update' /></button> :
                      <button className="primary" onClick={this.onSaveTransactionCommentClick} disabled><LanguageStringResolver string='transactionComment_update' /></button>
                    }
                    <button className="secondary" onClick={this.onDeleteTransactionCommentClick} enabled><LanguageStringResolver string='transactionComment_delete' /></button>
                  </div> :
                  <div>
                    {newCommentEntered ?
                      <button className="primary" onClick={this.onSaveTransactionCommentClick} enabled><LanguageStringResolver string='transactionComment_save' /></button> :
                      <button className="primary" onClick={this.onSaveTransactionCommentClick} disabled><LanguageStringResolver string='transactionComment_save' /></button>
                    }
                    <button className="secondary" onClick={this.onDeleteTransactionCommentClick} disabled><LanguageStringResolver string='transactionComment_delete' /></button>
                  </div>
                }
              </div>
            </Collapsible>

            <Collapsible trigger={attachmentTrigger}>
              <div className="flex-box-container relative z-index-1 pt15">
                <div className="clear"></div>
                {invoice.bookingInformation.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_bookingInformation' /></h2>
                    <BookingInformation bookingInformation={invoice.bookingInformation} />
                  </div>
                ) : (<div></div>)}

                <h2 className="mt15 mb5"><LanguageStringResolver string='transactionInvoice_processingDetails' /></h2>
                <table className="mb20">
                  <thead>
                    <tr>
                      <th className="half-width"><LanguageStringResolver string='transactionInvoice_processing_uploadFile' /></th>
                      <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_processing_program' /></th>
                      <th className="quarter-width"><LanguageStringResolver string='transactionInvoice_processing_date' /></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td><span>{invoice.containedInCollectionDocument}</span></td>
                      <td><span>{invoice.processedProgram_str} {invoice.processedVersion} ({invoice.databaseVersion})</span></td>
                      <td><span><FormattedDate value={invoice.processingDate} format='yyyy-mm-dd HH:MM:ss:l' /></span></td>
                    </tr>
                  </tbody>
                </table>

                {/* Transaction Reporting */}

                {/*VAT Return 14354 15112 */}
                {invoice.vatReturn.length > 0 ? (
                  <div>
                    <ReportVATReturn src={invoice.vatReturn} />
                  </div>
                ) : (<div></div>)}

                {/*EC Listing 14911 14920 */}
                {invoice.ecListing[0].ecListingLines.length || invoice.ecListing[1].ecListingLines.length || invoice.ecListing[2].ecListingLines.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_ECListing' /></h2>
                    <ReportECL src={invoice.ecListing} />
                  </div>
                ) : (
                  <div></div>)}

                {/*Local Listing 14354 14356 */}
                {invoice.localListing.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_localListing' /></h2>
                    <ReportLL src={invoice.localListing} />
                  </div>
                ) : (<div></div>)}

                {/* Reverse Charge Listing 14365 */}
                {invoice.reverseChargeListing.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_reverseChargeListing' /></h2>
                    <ReportRCL src={invoice.reverseChargeListing} />
                  </div>
                ) : (<div></div>)}

                {/*Intrastat Detail 17282 */}
                {invoice.intrastat.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_intrastat' /></h2>
                    <ReportIntrastat src={invoice.intrastat} />
                  </div>
                ) : (<div></div>)}

                {/*Ledgers 14354 14365 */}
                {invoice.ledgers.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_ledgers' /></h2>
                    <ReportLedgers src={invoice.ledgers} />
                  </div>
                ) : (<div></div>)}

                {/*Extrastat - No Test Data */}
                {invoice.extrastat.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_extrastat' /></h2>
                    <ReportExtrastat src={invoice.extrastat} />
                  </div>
                ) : (<div></div>)}

                {/*Refund - No Test Data */}
                {invoice.refund.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_refunds' /></h2>
                    <ReportRefund src={invoice.refund} />
                  </div>
                ) : (<div></div>)}

                {/*SII - Not Test Data */}
                {invoice.sii.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_SII' /></h2>
                    <ReportSII src={invoice.sii} />
                  </div>
                ) : (<div></div>)}

                {/*OSS Union*/}
                {invoice.ossUnion.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_OSSUnion' /></h2>
                    <ReportOSS src={invoice.ossUnion} isOSSUnion={true} />
                  </div>
                ) : (<div></div>)}

                {/*OSS Non-Union*/}
                {invoice.ossNonUnion.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_OSSNonUnion' /></h2>
                    <ReportOSS src={invoice.ossNonUnion} isOSSUnion={false} />
                  </div>
                ) : (<div></div>)}

                {/*OSS Import*/}
                {invoice.ossImport.length > 0 ? (
                  <div>
                    <h2 className="mt0 mb0"><LanguageStringResolver string='transactionInvoice_iOSS' /></h2>
                    <ReportOSS src={invoice.ossImport} isOSSUnion={false} />
                  </div>
                ) : (<div></div>)}
              </div>
            </Collapsible>
          </div>
        </div>
      </ReadOnlyWrapper>
    );
  }
}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & starting props', state, props);
  return {};
}


function mapDispatchersToProps(dispatch) {
  return {
    doGetTransactionComment: (transactionId, callback) => {
      log.debug('doGetTransactionComment: ', transactionId);
      dispatch(TRANSACTIONS_CONTROLLER.doGetTransactionComment(transactionId, callback));
    },
    doPutTransactionComment: (transactionId, newComment, callback) => {
      log.debug('doPutTransactionComment: ', transactionId, newComment);
      dispatch(TRANSACTIONS_CONTROLLER.doPutTransactionComment(transactionId, newComment, callback));
    },
    doDeleteTransactionComment: (transactionId, callback) => {
      log.debug('doDeleteTransactionComment: ', transactionId);
      dispatch(TRANSACTIONS_CONTROLLER.doDeleteTransactionComment(transactionId, callback));
    },
    doGetTransactionAttachment: (transactionId, callback) => {
      log.debug('doGetTransactionAttachment: ', transactionId);
      dispatch(TRANSACTIONS_CONTROLLER.doGetTransactionAttachment(transactionId, callback));
    },
    doDownloadTransactionAttachment: (params) => {
      log.debug('doDownloadTransactionAttachment: ', params);
      dispatch(TRANSACTIONS_CONTROLLER.doDownloadTransactionAttachment(params));
    },
    doUploadTransactionAttachment: (attachmentData, callback) => {
      log.debug('doUploadTransactionAttachment: ', attachmentData);
      dispatch(TRANSACTIONS_CONTROLLER.doUploadTransactionAttachment(attachmentData, callback));
    },
    doDeleteTransactionAttachment: (transactionId, callback) => {
      log.debug('doDeleteTransactionAttachment: ', transactionId);
      dispatch(TRANSACTIONS_CONTROLLER.doDeleteTransactionAttachment(transactionId, callback));
    }
  }
}

// This connects mapStateToProps and mapDispatchersToProps into Redux, effectively plumbing the Page to the app state
export default connect(mapStateToProps, mapDispatchersToProps)(TransactionInvoice);
